export default __webpack_public_path__ + "static/media/img (1).15d0f8d7.jpg";